import type { ReactNode } from 'react';

export const symbol_pen_size_2: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M203-233q0-12 9-21l494-494q8-8 20.5-8.5T748-748q9 9 9 21t-9 21L254-212q-9 9-21 9t-21-9q-9-9-9-21Z"
		/>
	</svg>
);
